export class CpfRequiredError extends Error {
  constructor() {
    super('CPF é obrigatório')
    this.name = 'CpfRequiredError'
  }
}
